<!--sidebar-->
@if (!hidenav && currentAccount) {
  <c-sidebar
    #sidebar="cSidebar"
    class="d-print-none sidebar-navigation-background"
    id="sidebar"
    [visible]="true"
    colorScheme="dark"
  >
    <c-sidebar-header class="justify-content-center bg-body">
      <c-sidebar-brand
        [brandFull]="{
          src: customLogo ? customLogo : 'assets/img/brand/firm360-logo-v2.png',
          height: 35,
          alt: 'Firm360 Logo',
        }"
        [brandNarrow]="{
          src: 'assets/img/brand/firm360-logo-sm-v2.png',
          width: 30,
          height: 30,
          alt: 'Firm360 Logo',
        }"
        routerLink="./"
      >
      </c-sidebar-brand>
    </c-sidebar-header>
    <ng-scrollbar [orientation]="'vertical'">
      <c-sidebar-nav [navItems]="navItems" dropdownMode="close"></c-sidebar-nav>
    </ng-scrollbar>
    <c-sidebar-footer
      class="custom-sidebar-footer mt-auto"
      toggle="unfoldable"
      cSidebarToggle="sidebar"
    >
      <button cSidebarToggler type="button">
        <!--            <svg cIcon name="cilArrowRight" size="lg"></svg>-->
      </button>
    </c-sidebar-footer>
  </c-sidebar>
}

<!--main-->
<div class="wrapper d-flex flex-column min-vh-100 bg-light dark:bg-transparent">
  <!--app-header-->
  @if (!hidenav && currentAccount) {
    <app-default-header
      class="mb-4 d-print-none header header-sticky shadow"
      position="sticky"
      sidebarId="sidebar"
    >
    </app-default-header>
  }
  <!--app-body-->
  <div class="body flex-grow-1 px-md-3">
    <c-container [fluid]="true" class="h-auto">
      <router-outlet></router-outlet>
    </c-container>
  </div>
  <!--app footer-->
  @if (!hidenav) {
    <app-default-footer></app-default-footer>
  }
</div>
